module.exports = __webpack_public_path__ + "static/media/videoIcon.60e032fd.png";